import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CardPopover from '../UI/CardPopover';
import Table from '../AgGrid';

const LastUploadCapacityReportPopup = ({
    anchorEl,
    onPopoverClose,
    lastUploadDate,
    lastUploadUser,
    tableRows,
    columnDefs,
}) => {
    const { t } = useTranslation();
    const displayDate = lastUploadDate?.endsWith('Uhr')
        ? lastUploadDate?.substring(0, lastUploadDate?.length - 3)
        : lastUploadDate;
    const hasTableRows = Array.isArray(tableRows) && tableRows.length > 0;

    return (
        <CardPopover
            anchorEl={anchorEl}
            onClose={onPopoverClose}
            className={`lastUploadPopover${hasTableRows ? ' hasRows' : ''}`}
        >
            <Grid item xs={12}>
                {lastUploadDate && lastUploadUser && (
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t('common.byUserAt', { date: displayDate, name: lastUploadUser?.name })}
                    </Typography>
                )}
            </Grid>
            <Grid item xs={12}>
                <Table
                    rowData={tableRows}
                    defaultColDef={{
                        editable: true,
                        filter: true,
                        sortable: true,
                    }}
                    columnDefs={columnDefs}
                ></Table>
            </Grid>
        </CardPopover>
    );
};

export default LastUploadCapacityReportPopup;
